<template>
  <div class="schedule-c--container">
    <div v-if="staffData.length === 0 && requestCount > 0" class="alert alert-sm alert-danger">
      Для работоспособности сервиса, вам необходимо последовательно создать:<br><br>
      - Компанию (Раздел "Компании/Филиалы")<br>
      - Услугу(-и) (Раздел "Услуги")<br> 
      - Сотрудника(-ов) (Раздел "Сотрудники")<br> 
      - Задать расписание сотрудникам (Раздел "Расписание")
    </div>
    <div v-if="mode == 'month'" class="schedule-c--month-container shadow-card">
      <div @click="prevMonth" class="left">
        <f-awesome icon="arrow-left"></f-awesome>
      </div>
      <div class="month">
        <b>{{ monthName[nowDate.getMonth()] }}</b>, {{ nowDate.getFullYear() }}
      </div>
      <div @click="nextMonth" class="right">
        <f-awesome icon="arrow-right"></f-awesome>
      </div>
    </div>
    <div v-if="mode == 'week'" class="schedule-c--week-container shadow-card">
      <div @click="prevWeek" class="left">
        <f-awesome icon="arrow-left"></f-awesome>
      </div>
      <div class="week">
        <b>{{ getWeekDate(dateFrom) }}</b> - <b>{{ getWeekDate(dateTo) }}</b>
      </div>
      <div @click="nextWeek" class="right">
        <f-awesome icon="arrow-right"></f-awesome>
      </div>
    </div>
    <div class="schedule-c--actions shadow-card">
      <div class="mode-block">
        <mode-journal
            :modeList="modeList"
            :modeActive="mode"
            @selectJournalMode="selectJournalMode"
        ></mode-journal>
      </div>
      <div>
        <div
          @click="showPlannerPopup"
          v-if="checkPermission('crud_schedule')" 
          class="btn btn-sm btn-orange mrg-b-10"
        >
          <f-awesome icon="clock"></f-awesome>
          Планировщик расписания
        </div>
        <div
          v-if="checkPermission('crud_schedule')"
          @click="showSetTimePopup"
          class="btn btn-sm btn-info mrg-b-10"
        >
          <f-awesome icon="plus"></f-awesome>
          Задать/убрать время
        </div>
        <div @click="showFastHighligthPopup" class="btn btn-sm btn-info mrg-b-10">
          <f-awesome icon="magic"></f-awesome> Быстрое выделение
        </div>
        <div @click="resetSelectDay" class="btn btn-sm btn-outline-info mrg-b-10">
          Снять выделенное
        </div>
      </div>
    </div>
    <div v-show="calendar.length" class="schedule-c--calendar-container no-select shadow-card">
      <div class="schedule-c--calendar-overflow mrg-t-15">
        <table class="schedule-c--calendar-table">
          <thead>
            <tr class="schedule-c--calendar-body schedule-c--calendar-dates">
              <th style="position: sticky; top: 0; left: 0; z-index: 1;" class="free-block"></th>
              <th 
                style="position: sticky; top: 0; left: 0; z-index: 1;" 
                v-for="day in calendar" 
                :key="day.day" 
                :class="{weekend: day.weekend === 1, today: day.today === true}"
              >
                <div>{{ day.day }}</div>
                <div>{{ day.weekday }}</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
                v-for="(item, key) in staffData"
                :key="key"
                class="schedule-c--calendar-body schedule-c--calendar-cells"
            >
              <th style="position: sticky; left: 0;" class="avatar">
                <div class="img"><img :src="item.avatar" /></div>
                <div class="name">{{item.name}}</div>
              </th>
              <td
                  class="cell"
                  v-for="(day, index) in item.calendar"
                  @click="selectDay(item.id, day.day, day.month)"
                  @mouseenter="lightCell(item.id, day.day, day.month)"
                  @mouseleave="unlightCell"
                  v-bind:class="{
                    active: day.active,
                    lightBright: day.lightBright,
                    lightPale: day.lightPale
                  }"
                  :key="index"
              >
                <div class="weekend" v-show="day.schedule.weekend == 1">Выходной</div>
                <div class="time" v-show="day.schedule.weekend != 1">
                  <div class="time_from" v-show="day.schedule.time_from">
                    {{ day.schedule.time_from }} - {{ day.schedule.time_to }}
                  </div>
                  <div class="break_from" v-show="day.schedule.breaks">
                    <div class="break_item" v-for="(breakItem, index) in day.schedule.breaks" :key="index">
                      {{ breakItem.break_from }} - {{ breakItem.break_to }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <popup
      :closeButton="setTimePopup.closeButton"
      :show="setTimePopup.show"
      @closePopup="closeSetTimePopup"
    >
      <div slot="header">Выбрать график</div>
      <div slot="body">
        <schedule-set-time
          :open="setTimePopup.show"
          :selectedStaff="selectedStaffIds"
          @setTime="setTimeSubmit"
        ></schedule-set-time>
      </div>
    </popup>

    <popup
        :closeButton="fastHighlightPopup.closeButton"
        :show="fastHighlightPopup.show"
        @closePopup="closeFastHighlightPopup"
    >
      <div slot="header">Быстрое выделение</div>
      <div slot="body">
        <div class="fast-highlight--container">
          <div class="title">Выберите сотрудников, для которых будет применяться быстрое выделение</div>
          <div class="fast-highlight--flex-list mrg-t-20">
            <div v-for="item in fastHighLightStaffs" :key="item.id" class="fast-highlight--flex-item">
              <div class="input-block">
                <label>
                  <input
                      type="checkbox"
                      v-model="item.active"
                  />
                  {{item.name}}
                </label>
              </div>
            </div>
          </div>
          <div class="title">Выберите, какие дни будем выделять</div>
          <div class="fast-highlight--flex-list mrg-t-20">
            <div class="fast-highlight--flex-item">
              <div class="input-block">
                <label>
                  <input
                      type="checkbox"
                      v-model="fastHighLightParams.select_chetn"
                  />
                  Выбрать четные дни
                </label>
              </div>
            </div>
            <div class="fast-highlight--flex-item">
              <div class="input-block">
                <label>
                  <input
                      type="checkbox"
                      v-model="fastHighLightParams.select_nechetn"
                  />
                  Выбрать нечетные дни
                </label>
              </div>
            </div>
            <div class="fast-highlight--flex-item">
              <div class="input-block">
                <label>
                  <input
                      type="checkbox"
                      v-model="fastHighLightParams.select_weekdays"
                  />
                  Выбрать будни
                </label>
              </div>
            </div>
            <div class="fast-highlight--flex-item">
              <div class="input-block">
                <label>
                  <input
                      type="checkbox"
                      v-model="fastHighLightParams.select_weekend"
                  />
                  Выбрать выходные
                </label>
              </div>
            </div>
          </div>
          <div class="input-block">
            <div @click="fastHighLightSubmit" class="btn btn-sm btn-success">Применить</div>
          </div>
        </div>
      </div>
    </popup>


    <popup
      :closeButton="plannerPopup.closeButton"
      :show="plannerPopup.show"
      @closePopup="closePlannerPopup"
    >
      <div slot="header">Автопланировщик расписания</div>
      <div slot="body">
        <schedule-planner :show="plannerPopup.show"></schedule-planner>
      </div>
    </popup>


  </div>
</template>

<script>
import Formatter from "../../libraries/Formatter";
import Popup from "../../Popup";
import ScheduleSetTime from "./ScheduleSetTime";
import ModeJournal from "@/components/panel/journal/ModeJournal";
import permissionMixin from "@/components/mixins/Permissions";
import SchedulePlanner from './SchedulePlanner.vue';
import scheduleRepository from "../../../repositories/schedule";

const formatter = new Formatter();

export default {
  name: "ScheduleCalendar",
  components: {ModeJournal, ScheduleSetTime, Popup, SchedulePlanner },
  mixins: [permissionMixin],
  data() {
    return {
      monthName: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь"
      ],
      weekdayName: ["Вскр", "Пнд", "Вт", "Ср", "Чтв", "Птн", "Сб"],
      weekdayNumber: [6, 0, 1, 2, 3, 4, 5],
      nowDate: new Date(),
      finalNowDate: new Date(),
      mode: "month",
      modeList: [
        {
          name: "Месяц",
          val: "month"
        },
        {
          name: "Неделя",
          val: "week"
        }
      ],
      calendar: [],
      staffData: [],
      requestCount: 0,
      setTimePopup: {
        show: false,
        closeButton: "Отмена"
      },
      fastHighlightPopup: {
        show: false,
        closeButton: "Отмена"
      },
      fastHighLightStaffs: [],
      fastHighLightParams: {
        select_chetn: false,
        select_nechetn: false,
        select_weekdays: false,
        select_weekend: false
      },
      dateFrom: null,
      dateTo: null,
      plannerPopup: {
        show: false,
        closeButton: "Закрыть"
      },
    };
  },
  props: {
    staff: Array
  },
  watch: {
    staff: function() {
      this.renderCalendar();
    },
    mode: function() {
      // Сбросим время при изменении режима отображения
      this.nowDate = new Date();
      this.renderCalendar();
    }
  },
  computed: {
    selectedStaffIds(){
      let result = [];
      for (let key in this.staffData) {
        for (let keyC in this.staffData[key].calendar) {
          if (this.staffData[key].calendar[keyC].active) {
            let existsStaff = false;
            for(let keyRes in result){
              if(result[keyRes] == this.staffData[key].id){
                existsStaff = true;
              }
            }
            if(!existsStaff){
              result[result.length] = this.staffData[key].id;
            }
          }
        }
      }
      return result;
    }
  },
  methods: {
    showPlannerPopup(){
      this.plannerPopup.show = true;
    },
    closePlannerPopup(){
      this.plannerPopup.show = false;
    },
    fastHighLightSubmit(){
      for(let keyHStaff in this.fastHighLightStaffs){
        if(this.fastHighLightStaffs[keyHStaff].active){
          for(let keyMStaff in this.staffData){
            if(this.staffData[keyMStaff].id === this.fastHighLightStaffs[keyHStaff].id){
              for(let calendar in this.staffData[keyMStaff].calendar){
                let day = this.staffData[keyMStaff].calendar[calendar].day;
                let weekdayNumber = +this.staffData[keyMStaff].calendar[calendar].weekdayNumber;
                if(
                    this.fastHighLightParams.select_chetn && !(day %2) ||
                    this.fastHighLightParams.select_nechetn && (day %2) ||
                    this.fastHighLightParams.select_weekdays && (weekdayNumber !== 0 && weekdayNumber !== 6) ||
                    this.fastHighLightParams.select_weekend && (weekdayNumber === 0 || weekdayNumber === 6)
                ){
                  this.$set(this.staffData[keyMStaff].calendar[calendar], 'active', true);
                }else{
                  this.$set(this.staffData[keyMStaff].calendar[calendar], 'active', false);
                }
              }
            }
          }
        }
      }
      this.closeFastHighlightPopup();
    },
    showFastHighligthPopup(){
      this.fastHighlightPopup.show = true;
    },
    closeFastHighlightPopup(){
      this.fastHighlightPopup.show = false;
    },
    selectJournalMode(val) {
      this.mode = val;
    },
    getWeekDate(date) {
      return formatter.phpDateToShortString(date);
    },
    filteredHighlightStaffData(data){
      let newData = data;
      for(let key in newData){
        newData[key].active = false;
        newData[key].select_chetn = false;
        newData[key].select_nechetn = false;
        newData[key].select_weekdays = false;
        newData[key].select_weekend = false;
      }
      return newData;
    },
    renderCalendar() {
      if (this.mode === "month") {
        this.renderMonth();
      } else if (this.mode === "week") {
        this.renderWeek();
      }
      this.fastHighLightStaffs = this.filteredHighlightStaffData(this.staff);
    },
    renderMonth() {
      let date = new Date(
        this.nowDate.getFullYear(),
        this.nowDate.getMonth(),
        1
      );
      let dayInMoth = 0;
      this.dateFrom = formatter.dateToPhpFormat(date);

      for (let i = 1; i <= 33; i++) {
        if (date.getDate() != i) {
          date.setDate(date.getDate() - 1);
          dayInMoth = date.getDate();
          this.dateTo = formatter.dateToPhpFormat(date);
          break;
        }
        date.setDate(date.getDate() + 1);
      }
      date = new Date(this.nowDate.getFullYear(), this.nowDate.getMonth(), 1);
      this.calendar = [];
      for (let i = 1; i <= dayInMoth; i++) {
        date = new Date(this.nowDate.getFullYear(), this.nowDate.getMonth(), i);
        let dayObj = {};
        dayObj.day = date.getDate();
        dayObj.month = date.getMonth();
        dayObj.year = date.getFullYear();
        dayObj.weekday = this.weekdayName[date.getDay()];
        dayObj.weekend = (date.getDay() == 0 || date.getDay() == 6?1:0);
        dayObj.today = formatter.isIdenticalDates(
          formatter.jsObjectToPhp(date),
          formatter.jsObjectToPhp(this.finalNowDate)
        );
        this.calendar.push(dayObj);
        // date.setDate(date.getDate() + 1);
      }

      let staffData = [];
      for (let key in this.staff) {
        let count = staffData.length;
        staffData[count] = {};
        staffData[count].id = this.staff[key].id;
        staffData[count].name = this.staff[key].name;
        staffData[count].avatar = this.staff[key].avatar;
        staffData[count].calendar = [];
        for (let i = 1; i <= dayInMoth; i++) {
          date = new Date(
            this.nowDate.getFullYear(),
            this.nowDate.getMonth(),
            i
          );
          let dayObj = {};
          dayObj.day = date.getDate();
          dayObj.month = date.getMonth();
          dayObj.year = date.getFullYear();
          dayObj.active = false;
          dayObj.lightPale = false;
          dayObj.lightBright = false;
          dayObj.weekdayNumber = date.getDay();
          dayObj.schedule = {};
          staffData[count].calendar.push(dayObj);
          // date.setDate(date.getDate() + 1);
        }
      }
      this.staffData = staffData;

      this.loadSchedule(this.dateFrom, this.dateTo);
    },
    renderWeek() {
      let nowDay = this.weekdayNumber[this.nowDate.getDay()];
      this.nowDate.setDate(this.nowDate.getDate() - nowDay);

      let date = new Date(
        this.nowDate.getFullYear(),
        this.nowDate.getMonth(),
        this.nowDate.getDate()
      );
      this.dateFrom = formatter.dateToPhpFormat(date);

      this.calendar = [];
      for (let i = 0; i <= 6; i++) {
        let dayObj = {};
        dayObj.day = date.getDate();
        dayObj.month = date.getMonth();
        dayObj.year = date.getFullYear();
        dayObj.weekday = this.weekdayName[date.getDay()];
        dayObj.weekend = (date.getDay() == 0 || date.getDay() == 6?1:0);
        
        dayObj.today = formatter.isIdenticalDates(
          formatter.jsObjectToPhp(date),
          formatter.jsObjectToPhp(this.finalNowDate)
        );
        this.calendar.push(dayObj);
        if (i === 6) {
          this.dateTo = formatter.dateToPhpFormat(date);
        }
        date.setDate(date.getDate() + 1);
      }

      let staffData = [];
      for (let key in this.staff) {
        let count = staffData.length;
        staffData[count] = {};
        staffData[count].id = this.staff[key].id;
        staffData[count].name = this.staff[key].name;
        staffData[count].avatar = this.staff[key].avatar;
        staffData[count].calendar = [];
        date = new Date(
          this.nowDate.getFullYear(),
          this.nowDate.getMonth(),
          this.nowDate.getDate()
        );
        for (let i = 0; i <= 6; i++) {
          let dayObj = {};
          dayObj.day = date.getDate();
          dayObj.month = date.getMonth();
          dayObj.year = date.getFullYear();
          dayObj.active = false;
          dayObj.lightPale = false;
          dayObj.lightBright = false;
          dayObj.schedule = {};
          staffData[count].calendar.push(dayObj);
          date.setDate(date.getDate() + 1);
        }
      }
      this.staffData = staffData;

      this.loadSchedule(this.dateFrom, this.dateTo);
    },
    loadSchedule(dateFrom, dateTo) {
      this.$store.dispatch("startPreloader");

      scheduleRepository.getSchedule({
        dateFrom: dateFrom,
        dateTo: dateTo
      }).then(resp => {
        this.setSchedule(resp.data);
        this.requestCount++;
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("stopPreloader");
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    setSchedule(data) {
      for (let sc in data) {
        let date = formatter.phpDateToJSObject(data[sc].date);
        for (let staff in this.staffData) {
          if (+data[sc].staff_id === +this.staffData[staff].id) {
            for (let cal in this.staffData[staff].calendar) {
              let dateCalendar = formatter.paramsDateToJSObject(
                this.staffData[staff].calendar[cal].day,
                this.staffData[staff].calendar[cal].month,
                this.staffData[staff].calendar[cal].year
              );
              if (dateCalendar.getTime() === date.getTime()) {
                this.$set(
                  this.staffData[staff].calendar[cal].schedule,
                  "time_from",
                  formatter.minuteToTime(data[sc].time_from)
                );
                this.$set(
                  this.staffData[staff].calendar[cal].schedule,
                  "time_to",
                  formatter.minuteToTime(data[sc].time_to)
                );

                for(let breakItem in data[sc].breaks){
                  data[sc].breaks[breakItem].break_from = formatter.minuteToTime(data[sc].breaks[breakItem].break_from);
                  data[sc].breaks[breakItem].break_to = formatter.minuteToTime(data[sc].breaks[breakItem].break_to);
                }

                this.$set(
                    this.staffData[staff].calendar[cal].schedule,
                    "breaks",
                    data[sc].breaks
                );

                this.$set(
                  this.staffData[staff].calendar[cal].schedule,
                  "weekend",
                  data[sc].weekend
                );
              }
            }
          }
        }
      }
    },
    selectDay(staff, day, month) {
      for (let key in this.staffData) {
        if (+this.staffData[key].id === +staff) {
          for (let keyC in this.staffData[key].calendar) {
            if (
              +this.staffData[key].calendar[keyC].day === +day &&
              +this.staffData[key].calendar[keyC].month === +month
            ) {
              this.staffData[key].calendar[keyC].active = !this.staffData[key]
                .calendar[keyC].active;
            }
          }
        }
      }
    },
    resetSelectDay() {
      for (let key in this.staffData) {
        for (let keyC in this.staffData[key].calendar) {
          this.staffData[key].calendar[keyC].active = false;
        }
      }
    },
    prevMonth() {
      this.nowDate.setDate(1);
      this.nowDate.setMonth(this.nowDate.getMonth() - 1);
      this.renderCalendar();
    },
    nextMonth() {
      this.nowDate.setDate(1);
      this.nowDate.setMonth(this.nowDate.getMonth() + 1);
      this.renderCalendar();
    },
    nextWeek() {
      this.nowDate.setDate(this.nowDate.getDate() + 7);
      this.renderCalendar();
    },
    prevWeek() {
      this.nowDate.setDate(this.nowDate.getDate() - 7);
      this.renderCalendar();
    },
    showSetTimePopup() {
      let activeRes = false;
      for (let key in this.staffData) {
        for (let keyC in this.staffData[key].calendar) {
          if (this.staffData[key].calendar[keyC].active) {
            activeRes = true;
          }
        }
      }
      if (!activeRes) {
        this.$store.dispatch("addNotification", {
          text: "Выделите дни у сотрудников, в которые будете задавать расписание",
          time: 4,
          color: "danger"
        });
        return false;
      }
      this.setTimePopup.show = true;
    },
    closeSetTimePopup() {
      this.setTimePopup.show = false;
    },
    setTimeSubmit(val) {
      this.$store.dispatch("startPreloader");
      let data = [];
      for (let key in this.staffData) {
        for (let keyC in this.staffData[key].calendar) {
          if (this.staffData[key].calendar[keyC].active) {
            let obj = {};
            obj.staff_id = this.staffData[key].id;
            obj.date = formatter.paramsDateToPhpFormat(
              this.staffData[key].calendar[keyC].day,
              this.staffData[key].calendar[keyC].month,
              this.staffData[key].calendar[keyC].year
            );
            obj.schedule = val;
            data.push(obj);
          }
        }
      }

      scheduleRepository.setSchedule({
        data: JSON.stringify(data),
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      }).then(resp => {
        this.setSchedule(resp.data.data);
        this.setTimePopup.show = false;
        this.$store.dispatch("stopPreloader");
        this.resetSelectDay();
        this.$store.dispatch("addNotification", {
          text: 'Успешно',
          time: 2,
          color: "success"
        });
      }).catch(err => {
        this.$store.dispatch("stopPreloader");
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    lightCell(staff, day, month) {
      for (let key in this.staffData) {
        if (+this.staffData[key].id === +staff) {
          for (let cal in this.staffData[key].calendar) {
            if (
              +this.staffData[key].calendar[cal].day === +day &&
              +this.staffData[key].calendar[cal].month === +month
            ) {
              this.staffData[key].calendar[cal].lightBright = true;
            } else {
              this.staffData[key].calendar[cal].lightPale = true;
            }
          }
        } else {
          for (let cal in this.staffData[key].calendar) {
            if (
              +this.staffData[key].calendar[cal].day === +day &&
              +this.staffData[key].calendar[cal].month === +month
            ) {
              this.staffData[key].calendar[cal].lightPale = true;
            }
          }
        }
      }
    },
    unlightCell() {
      for (let key in this.staffData) {
        for (let cal in this.staffData[key].calendar) {
          this.staffData[key].calendar[cal].lightBright = false;
          this.staffData[key].calendar[cal].lightPale = false;
        }
      }
    }
  },
  created() {
    if(this.staff.length){
      this.renderCalendar();
    }
  },
  mounted() {
    let height = document.documentElement.clientHeight;
    let calendarOverflow = document.getElementsByClassName('schedule-c--calendar-overflow');
    if(calendarOverflow.length){
      calendarOverflow[0].style.height = height - 280 + 'px';
    }

    window.addEventListener('resize', function(){
      let height = document.documentElement.clientHeight;
      let calendarOverflow = document.getElementsByClassName('schedule-c--calendar-overflow');
      if(calendarOverflow.length){
        calendarOverflow[0].style.height = height - 280 + 'px';
      }
    });
  }
};
</script>

<style scoped lang="less">
.schedule-c--calendar-container {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  color: #4F4F4F;
}
.schedule-c--calendar-overflow {
  overflow: scroll;
  max-width: 100%;
  position: relative;
  height: 400px;
}
.schedule-c--calendar-table{
  position: relative;
  border-collapse: collapse;
}
.schedule-c--calendar-body {
  & > th, td {
    text-align: center;
    min-width: 75px;
    max-width: 350px;
    width: 300px;
    min-height: 75px;
    border-bottom: .5px solid #C4C4C4;
    padding: 4px;
    box-sizing: border-box;
    cursor: pointer;
  }

  & > th:nth-of-type(1), td:nth-of-type(1) {
    border-right: .5px solid #C4C4C4;
  }

  & > th:not(:nth-of-type(1)), td:not(:nth-of-type(1)) {
    border-right: .5px solid #C4C4C4;
  }
}
.schedule-c--calendar-dates {

  & > th, td{
    font-size: 18px;
    background-color: #fff;
  }


  .weekend{
    color: #F97979;
  }
  .today{
    background-color: rgb(236, 236, 236);
  }
}
.schedule-c--calendar-cells {
  .active {
    background-color: #ffbcb9;
  }
  .avatar {
    padding-top: 6px;
    box-sizing: border-box;
    background-color: #F0F4F9;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;

    .name{
      font-size: 9px;
      color: #41A2FC;
    }

    img {
      width: 45px;
    }
  }
  .cell{

    .weekend{
      font-size: 14px;
      color: #F97979;
    }
    .time{
      .time_from{
        font-size: 12px;
        font-weight: 700;
      }
      .break_from{
        margin-top: 10px;
        font-size: 10px;
        color: #F97979;
      }
    }
  }
}
.schedule-c--actions {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;
  margin-top: 10px;
  margin-bottom: 18px;

  & > div:nth-of-type(1) {
    width: 15%;
  }
  & > div:nth-of-type(2) {
    width: 65%;
    text-align: right;
  }
}
.lightBright {
  background-color: #41A2FC;
}
.lightPale {
  background-color: #DBEEFF;
}

.schedule-c--month-container,
.schedule-c--week-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  flex-direction: row;

  .left {
    cursor: pointer;
    text-align: right;
    width: 100px;
  }
  .month,
  .week {
    text-align: center;
    width: auto;
    padding: 0 60px;
    font-size: 18px;
    color: #333;
  }
  .right {
    text-align: left;
    cursor: pointer;
    width: 100px;
  }
}
.fast-highlight--container{
  .title{
    font-size: 16px;
    font-weight: 700;
    color: #4F4F4F;
  }
  .fast-highlight--flex-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    flex-direction: row;

    .fast-highlight--flex-item{
      width: 50%;
    }
  }
}
@media (max-width: 900px) {
  .schedule-c--actions {
    flex-wrap: wrap;
    justify-content: space-around;
    margin-top: 15px;

    & > div:nth-of-type(1) {
      width: 65%;
      text-align: center;
    }
    & > div:nth-of-type(2) {
      margin-top: 20px;
      width: 100%;
      text-align: center;
    }
  }
}
@media (max-width: 700px) {
  .schedule-c--month-container,
  .schedule-c--week-container {

    .left {
      cursor: pointer;
      text-align: right;
      width: 60px;
    }
    .month,
    .week {
      width: auto;
      padding: 0 60px;
      font-size: 15px;
    }
    .right {
      width: 60px;
    }
  }
}
</style>
